// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const TailorFrameworkExample: MarkdocTagRegistration = {
  tag: 'tailor-framework-example',
  component: 'TailorFrameworkExample',
  attributes: {
    type: {
      type: String,
      required: true,
    },
    args: {
      type: Object,
      required: false,
    },
  },
};
